global.renderValue = function(value) {
	document.getElementById('coverage__value').innerHTML = value;
}